import { render } from "./DemandLetter.vue?vue&type=template&id=d5e4213a&scoped=true"
import script from "./DemandLetter.vue?vue&type=script&lang=js"
export * from "./DemandLetter.vue?vue&type=script&lang=js"

import "./DemandLetter.vue?vue&type=style&index=0&id=d5e4213a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e4213a"]])

export default __exports__